const ALLOWED_EMAILS = ['ontruck.com', 'ontruck.io'];

export const isValidOntruckEmail = (email) => {
  return ALLOWED_EMAILS.indexOf(email.split('@')[1]) >= 0;
};

export const isEmail = (email) => {
  return /^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/i.test(email);
};
